<template>
  <div>
    <header-slot>
      <template v-slot:content-right>
        <!-- <div class="mr-2">
          <b-button
            v-b-tooltip.hover.right="$t('Register Discount')"
            v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="outline-success"
            @click="openClientModal"
          >
            <div class="d-flex justify-content-between">
              <span> {{ $t("CREATE") }} </span>
            </div>
          </b-button>
        </div> -->
      </template>
    </header-slot>
    
    <b-nav card-header pills class="m-0">
      <b-nav-item
        v-for="(item, index) in tabs"
        :key="index"
        :to="{ name: item.name }"
        exact
        exact-active-class="sub-tab-nav"
        :link-classes="['sub-tab-nav', 'px-3', bgTabsNavs]"
        >{{ $t(item.title) }}
      </b-nav-item>
    </b-nav>
    <b-card no-body class="border-top-info border-3 border-table-radius px-0">
      <router-view ref="routerViewTab" :key="routeName" />
    </b-card>
  </div>
</template>


<script>
/* SERVICES */
import Ripple from "vue-ripple-directive";

export default {
  components: {},
  directives: {
    Ripple,
  },
  data() {
    return {
      sidebarEmployee: false,
      filters: false,
    };
  },
  created() {},
  computed: {
    tabs() {
      return this.$route.matched[2].meta.tabs;
    },
    currentTab() {
      return this.$route.meta.tab;
    },
    routeName() {
      return this.$route.name;
    },
  },
  methods: {
    // metodo concatenado de src/views/rrhh/views/payroll/Payroll.vue
    openModalDiscount() {
      this.$refs["routerViewTab"].openModalDiscount();
    },
  },
};
</script>
    
    
    